import React, { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { getOtherProperties, getRect, getTouchEvent } from "../common/Utils";
// import { addClass, css } from "../common/Dom";
import { RippleProps } from "./PropsType";

export default function Ripple(props: RippleProps) {
  const {
    centerMode,
    className,
    hidden = true,
    prefixCls = "bm-Ripple",
    size: sizeProps,
    ...other
  } = props;
  const groupClass = classNames(`${prefixCls}-group`, {
    [`${prefixCls}-hidden`]: hidden,
  });
  // const styles = {
  //   backgroundColor: props.rippleColor!,
  // };
  // const [children, setChildren] = useState<string[]>([]);
  const otherProps = getOtherProperties(other, ["centerMode", "rippleColor"]);
  
  const [styles, setStyles] = useState<any>([]);
  const rippleNode = useRef(null);
  const seed = useRef(0);
  const getUuid = () => {
    const now: any = new Date();
    seed.current = seed.current++;
    return `Ripple-${now.getTime()}_${seed.current}`;
  };

  const getPoint = (event: any) => {
    const touchEvent: any = getTouchEvent();
    event = event || window.event;
    return touchEvent.mobile ? event.changedTouches[0] : event;
  };

  const ripple = (event: any, key: any) => {
    if (!rippleNode.current) {
      return;
    }
    const touchEvent = getPoint(event);
    let x =
      touchEvent.pageX ||
      document.documentElement.scrollLeft +
        document.body.scrollLeft +
        touchEvent.clientX;
    let y =
      touchEvent.pageY ||
      document.documentElement.scrollTop +
        document.body.scrollTop +
        touchEvent.clientY;
    const parentNode: any = (rippleNode.current as HTMLDivElement).parentNode;
    const { offsetWidth, offsetHeight } = parentNode;
    const scale = sizeProps === "sm" ? 2 : 1;
    const size = Math.max(offsetWidth, offsetHeight) * 2;
    const rect = getRect(parentNode);
    if (!centerMode) {
      x = x - rect.left - size / 2;
      y = y - rect.top - size / 2;
    } else {
      x = y = -size / 4;
    }
    if (sizeProps === "sm") {
      x = y = 0;
    }
    // css(element, {
    //   width: size / scale + "px",
    //   height: size / scale + "px",
    //   top: y + "px",
    //   left: x + "px",
    // });
    // addClass(element, `${prefixCls!}-Effect`);
    setStyles((prev) => {
      const data = [...prev];
      data.push({
        key,
        style: {
          width: size / scale + "px",
          height: size / scale + "px",
          top: y + "px",
          left: x + "px",
        },
        clz: `${prefixCls!}-Effect`,
      });
      return data;
    });
  };

  const handleTouchStart = (event: any) => {
    if (rippleNode.current) {
      const key = getUuid();
      ripple(event, key);
    }
  };

  const handleAnimationEnd = (key: string) => {
    const data: any = styles.filter((child) => {
      return key !== child.key;
    });
    setStyles(data);
  };

  useEffect(() => {
    const touchEvent: any = getTouchEvent();
    if (rippleNode.current) {
      (rippleNode.current as HTMLDivElement)?.parentNode?.addEventListener(
        touchEvent.touchstart,
        handleTouchStart
      );
    }
    return () => {
      if (rippleNode.current) {
        (rippleNode.current as HTMLDivElement)?.parentNode?.removeEventListener(
          touchEvent.touchstart,
          handleTouchStart
        );
      }
    };
  }, []);

  return (
    <div className={groupClass} ref={rippleNode}>
      {styles.map((child: any) => {
        return (
          <div
            key={child.key}
            className={classNames(prefixCls, className, child.clz)}
            style={{
              ...child.style,
              backgroundColor: props.rippleColor!,
            }}
            {...otherProps}
            onAnimationEnd={handleAnimationEnd.bind(this, child.key)}
          ></div>
        );
      })}
    </div>
  );
}
